import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { useSelector } from "react-redux";
import { RootState } from "../redux/Store";

const TestimonialSlider = () => {
  const testimonials = useSelector(
    (state: RootState) => state.Testimonial?.testimonials
  );

  if (!testimonials.length) {
    return <p className="text-center text-gray-500">No testimonials yet.</p>;
  }

  return (
    <div className=" mx-auto py-10">
      <h2 className="text-xl md:text-2xl font-semibold text-center mb-6">
        What Our Clients Say
      </h2>
      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        spaceBetween={30}
        loop={true}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="p-6"
      >
        {testimonials.map((testimonial) => (
          <SwiperSlide key={testimonial.$id} className="px-8 md:p-12 pb-3">
            <div className="bg-white shadow-lg rounded-lg p-2 md:p-5 text-center">
              <img
                src={testimonial.image || "https://placehold.co/600x400"}
                alt={testimonial.name}
                className="w-16 h-16 mx-auto rounded-full mb-3 object-cover"
              />
              <h3 className="text-base font-semibold">{testimonial.name}</h3>
              <h3 className="text-xs mb-1">{testimonial.occupation}</h3>
              <p className="text-sm text-gray-500">{testimonial.heading}</p>
              <p className="mt-3 text-gray-700">{testimonial.review}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default TestimonialSlider;
